export const announcements = [
  {
    id: 1,
    title: '海角论坛2026年社区规范更新公告',
    date: '2026-08-01',
    isImportant: true,
    link: '/article/1',
  },
  {
    id: 2,
    title: '关于新增"AI前沿"板块的通知',
    date: '2026-07-28',
    isImportant: true,
    link: '/category/tech-discuss',
  },
  {
    id: 3,
    title: '海角论坛App 5.0版本正式发布',
    date: '2026-07-20',
    isImportant: false,
    link: '/article/3',
  },
  {
    id: 4,
    title: '2026年第二季度优秀版主评选结果',
    date: '2026-07-15',
    isImportant: false,
    link: '/category/career-education',
  },
  {
    id: 5,
    title: '论坛服务器升级维护通知（7月10日）',
    date: '2026-07-08',
    isImportant: false,
    link: '/',
  },
];